const r = "drawer", e = "drawer__container", a = "drawer__header", t = "drawer__title", d = "drawer__content", o = "drawer__footer", w = {
  drawer: r,
  "drawer--bottom": "drawer--bottom",
  "drawer--top": "drawer--top",
  "drawer--left": "drawer--left",
  "drawer--right": "drawer--right",
  "drawer--full-size": "drawer--full-size",
  "drawer--open": "drawer--open",
  "drawer--closing": "drawer--closing",
  drawer__container: e,
  drawer__header: a,
  drawer__title: t,
  "drawer__close-button": "drawer__close-button",
  drawer__content: d,
  drawer__footer: o
};
export {
  w as default,
  r as drawer,
  e as drawer__container,
  d as drawer__content,
  o as drawer__footer,
  a as drawer__header,
  t as drawer__title
};
